import { RefObject, useEffect } from 'react';

const useHandleOutsideClick = (ref: RefObject<HTMLDivElement>, callback: () => void) => {
  const handleClick = (event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target as Node)) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);
};

export { useHandleOutsideClick };
